import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SSOLinksResponseKeys } from '../../api/Constants';
import SSOLinksInterface from '../../api/SSOLinksInterface';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '..';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { setOnboardingStep as _setOnboardingStep } from '../../state/actions/currentOnboarding';
import { markOnboardingSeen as _markOnboardingSeen } from '../../state/actions/ftue';
import { setAuthCallbackIntent as _setAuthCallbackIntent } from '../../state/actions/callbackIntent';
import Utils from '../../utils';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { AUTH_TYPES } from '../../utils/authFlow/constants';

var LinkCardOnboarding = /*#__PURE__*/function (_Component) {
  _inherits(LinkCardOnboarding, _Component);

  var _super = _createSuper(LinkCardOnboarding);

  function LinkCardOnboarding() {
    var _this;

    _classCallCheck(this, LinkCardOnboarding);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.isRN = Utils.isReactNative();

    _this._finishOnboarding = function () {
      var _this$props = _this.props,
          markOnboardingSeen = _this$props.markOnboardingSeen,
          setOnboardingStep = _this$props.setOnboardingStep;
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      setOnboardingStep('');
      markOnboardingSeen(ONBOARDING_FLOWS.REWARD_CENTER);
    };

    _this._showUpgradeFlow = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this._finishOnboarding();

              if (_this.isRN) {
                _this._loginHandler();
              } else {
                _this._ssoLoginHandler();
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this._loginHandler = function () {
      if (ENVIRONMENT_VARIABLES.SSO_ENABLED.toString() !== 'true') {
        _this.handleLinkAccountForm();

        return false;
      }

      if (ENVIRONMENT_VARIABLES.SSO_ENABLED.toString() === 'true') {
        _this.props.setAuthCallbackIntent(AUTH_TYPES.LINK);

        QueryParamProxy.navigate(_this.props.navigation, Screens.SSOLogin);
      } else {
        QueryParamProxy.navigate(_this.props.navigation, Screens.Login);
      }
    };

    _this._ssoLoginHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var ssoLinks, destinationUrl;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(ENVIRONMENT_VARIABLES.SSO_ENABLED.toString() !== 'true')) {
                _context2.next = 3;
                break;
              }

              _this.handleLinkAccountForm();

              return _context2.abrupt("return", false);

            case 3:
              _context2.next = 5;
              return SSOLinksInterface.getSSOLinks();

            case 5:
              ssoLinks = _context2.sent;
              destinationUrl = ssoLinks[SSOLinksResponseKeys.LOGIN_URL];

              if (ENVIRONMENT_VARIABLES.SSO_DEV && ENVIRONMENT_VARIABLES.SSO_DEV.toString() === 'true') {
                destinationUrl = destinationUrl.replace(new RegExp("(redirect_uri=)(.*)(/".concat(ENVIRONMENT_VARIABLES.SSO_CALLBACK_PATH, ")")), "$1".concat(document.location.origin, "$3"));
              }

              document.location = destinationUrl;

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.handleLinkAccountForm = function () {
      return QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LinkAccountForm));
    };

    _this._dismissLinkAccountPopUp = function () {
      _this._finishOnboarding();

      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.RewardCenter));
    };

    return _this;
  }

  _createClass(LinkCardOnboarding, [{
    key: "render",
    value: function render() {
      return this.props.render({
        showUpgradeFlow: this._showUpgradeFlow,
        dismissLinkAccountPopUp: this._dismissLinkAccountPopUp,
        linkedLoyaltyCardBonus: this.props.linkedLoyaltyCardBonus
      });
    }
  }]);

  return LinkCardOnboarding;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  var linkedLoyaltyCardBonus = state.load.initAppResponse.SETTINGS.linkedLoyaltyCardBonus;
  return {
    linkedLoyaltyCardBonus: linkedLoyaltyCardBonus,
    isAccountLinked: state.playerInfo.isAccountLinked
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setOnboardingStep: function setOnboardingStep(step) {
      dispatch(_setOnboardingStep(step));
    },
    markOnboardingSeen: function markOnboardingSeen(onboardingFlow) {
      dispatch(_markOnboardingSeen(onboardingFlow));
    },
    setAuthCallbackIntent: function setAuthCallbackIntent(value) {
      dispatch(_setAuthCallbackIntent(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkCardOnboarding);